import * as service from "../service";
import { store } from "../../store";
import { controlLoading } from "../../slices/app.slice";
import type { ServiceResponse } from "../types";

export type UpdateVerificationParams = {
  student_card_number?: string;
  student_card_name?: string;
  hkid_number?: string;
  hkid_name?: string;
  student_id: string; // student's user id
  document?: "student_card" | "hkid";
};

export type UpdateVerificationResult = Record<string, any>;

/**
 * Update student verification info (admin only).
 * Backend: PATCH /api/student/updateVerification
 */
export const UpdateVerificationAPI = async (
  params: UpdateVerificationParams,
): Promise<ServiceResponse<UpdateVerificationResult>> => {
  const admin = store.getState().auth.admin;
  try {
    const resp = (await service.call(
      "PATCH",
      "/api/student/updateVerification",
      { ...params, admin_id: admin.id },
    )) as ServiceResponse<UpdateVerificationResult>;
    if (resp?.status === 0) {
      store.dispatch(controlLoading({ showLoading: false }));
    }
    return resp;
  } catch (err) {
    console.error(`UpdateVerificationAPI ${err}`);
    return { status: -1, error: err };
  }
};